
import ReportService from '../services/ReportService';
import TokenService from '../services/TokenService';
import TimeRanges from './TimeRanges';

const store = {
    state: {
        page: 1,
        limit: 100,
        search: '',
        report: {},
        loading: null,
        initialLoadCompleted: false,
        error: false,
        sort: {
            sortKey: 'visits',
            sortDirection: 'desc'
        },
        columns: []
    },
    getters: {
        columnsVisibilityMap: (state) => getColumnsVisibilityMap(state.columns)
    },
    mutations: {
        setLoading (state, loading) {
            state.loading = loading;
        },
        
        setInitialLoadingCompleted (state) {
            state.initialLoadCompleted = true;
        },

        setReport (state, report) {
            state.report = report;
        },
        
        setColumns: (state, columns) => {
            state.columns = columns;
        },

        setError: (state, error) => {
            state.error = error;
        },
        
        setPage: preventWhenLoading((state, page) => {
            if(page > 0) {
                state.page = page;
            }
        }),

        setLimit: preventWhenLoading((state, limit) =>{
            state.limit = limit;
        }),

        setSearch: preventWhenLoading((state, search) => {
            state.search = search;
        }),

        setSort: preventWhenLoading((state, sort) => {
            state.sort = sort;
        }),

        columnsVisibilityChanged (state, newColumns) {
            const newColumnsMap = getColumnsVisibilityMap(newColumns);
            const clonedColumns = state.columns.map(column => clone(column));
            
            clonedColumns.forEach((column) => {
                if(newColumnsMap[column.key] !== undefined) {
                    column.visible = newColumnsMap[column.key];
                } 
            });

            state.columns = clonedColumns;
        }
    },
    actions: {
        loadReport: function (context) {
            if(!context.state.loading) {
                context.commit('setLoading', true);
    
                const reportParams = {
                    page: context.state.page, 
                    limit: context.state.limit, 
                    filter: context.state.search, 
                    sort: context.state.sort
                };

                ReportService.getReport(TokenService.getToken(), reportParams)
                    .then(report => {
                        const currentColumnsVisibility = context.getters.columnsVisibilityMap;

                        const columns = report.columnMappings;
                        
                        columns.forEach(column => {
                            const previousVisibility = currentColumnsVisibility[column.key];
                            column.width = 'auto';
                            column.visible = previousVisibility !== undefined ? previousVisibility : true;
                        });

                        report.timeRangeLabel = TimeRanges.findTimeRangeLabel(report.from, report.to);

                        context.commit('setReport', report);
                        context.commit('setColumns', columns);
        
                        promiseFinaly(context);
                    })
                    .catch(() => {
                        context.commit('setError', true);

                        promiseFinaly(context);
                    });
            }
        }
    }
};

function promiseFinaly(context) {
    context.commit('setLoading', false);
    if(!context.state.initialLoadCompleted) {
        context.commit('setInitialLoadingCompleted');
    }
}

function getColumnsVisibilityMap(columns) {
    return columns.reduce((previous, current) => {
        previous[current.key] = current.visible;
        return previous;
    }, {});
}

function preventWhenLoading(cb) {
    return function (state, ...rest) {
        if(!state.loading) {
            cb(state, ...rest);
        }
    };
}

function clone(anything) {
    return JSON.parse(JSON.stringify(anything));
}

export default store;


// WEBPACK FOOTER //
// ./src/store/Store.js